/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: MyLabelOriginConfig.tsx
 * Project: mle-client-n
 * Committed last: 2022/6/1 @ 178
 * ---
 * Description:
 */

import {BaseDialogProps, HasEditor} from '../../../../common/props';
import {observer} from 'mobx-react';
import classNames from 'classnames';
import {currentThemeIsDark} from '../../../../common/utils';
import {Button, ButtonProps, Classes, Dialog, Intent} from '@blueprintjs/core';
import {useCallback} from 'react';
import {MyLabelCompanyMeta, MyLabelRevision} from '../../../../entities';
import {SwitchActiveRevisionPanel} from '../../panels/SwitchActiveRevisionPanel';

interface Props extends HasEditor, BaseDialogProps {
  showCloseButton?: boolean;
  closeButtonProps?: Partial<ButtonProps>;
}

export const MyLabelOriginConfig = observer((props: Props) => {

  const handleSelectRecipe = useCallback((item: MyLabelRevision) => {
    props.editor.recipeSwitcher.setActiveRevision(item?.id);
    props.editor.saveFeature.encodeAndUpload();
  }, [ props.editor.recipeSwitcher ]);

  const handleSelectCompany = useCallback((company: MyLabelCompanyMeta) => {
    props.editor.recipeSwitcher.setActiveCompany(company.id);
    props.editor.saveFeature.encodeAndUpload();
  }, [props.editor.recipeSwitcher, props.editor.recipeSwitcher.setActiveCompany]);

  return (
    <Dialog
      usePortal
      className={ classNames({ 'bp4-dark': currentThemeIsDark() }) }
      style={ { width: '35rem', height: '25rem' } }
      isOpen={ props.isOpen }
      title="Configurazione MyLabel"
      onClose={ props.onClose }
      canOutsideClickClose={ false }
    >
      <div className={ Classes.DIALOG_BODY }>
        <SwitchActiveRevisionPanel onCompanySelect={ handleSelectCompany }
                                   onRecipeSelect={ handleSelectRecipe }
                                   editor={ props.editor }
                                   className="h-3/4"
        />
        {
          props.showCloseButton === true &&
          <div className="w-full flex flex-row justify-end mt-12"><Button
            intent={ Intent.PRIMARY }
            onClick={ props.onClose } { ...props.closeButtonProps }>Salva e
            chiudi</Button>
          </div>
        }
      </div>
    </Dialog>
  );
});
